$(document).ready(function(){
  
    $('.slick-item').slick({
        slidesToShow: 2,
        arrows: true,
        infinite: false,
        swipe: true,        // Disables swipe
        touchMove: true,
       prevArrow: `<button type="button" class="slick-prev custom-slick-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="#000000">
       <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
     </svg>
      </button>`,
      nextArrow: `<button type="button" class="slick-next custom-slick-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="#000000">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
      </svg>
      </button>`,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow:6 
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 5
            }
          }
      ]
    });
});